import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  
   /**
   * Format a date to be user friendly ( DD/MM/YYYY )
   * @param date a valid string representation of the date to format
   * @returns 2021-06-15T04:29:00.000Z ==> 15/06/2021
   */
    public getNiceDate(date: string){
      let newDate = new Date(date);
      return this.getNiceDateFromDate(newDate);
    }
  
   /**
   * Format a date toto locale FR date format
   * @param date a valid string representation of the date to format
   * @returns 2021-06-15T04:29:00.000Z ==> 15/06/2021
   */
    public getNiceLocaleDate(date: string){
      let newDate = new Date(date);
      return this.getLocaleDateFromDate(newDate);
    }

    public getNiceDateFromDate(date: Date){
      let day = date.getDate().toString();
      let month = (date.getMonth()+1).toString();

      day = date.getDate() < 10 ? '0' + day : day;
      month = date.getMonth()+1 < 10 ? '0' + month : month;

      return day + '/' + month + '/' + date.getFullYear();
    }

    public getLocaleDateFromDate(date: Date){
      return date.toLocaleString('fr-FR');
    }

 /**
   * Format a date to be user friendly ( DD/MM/YYYY:HH:mm )
   * @param date a valid string representation of the date to format
   * @returns 2021-06-15T04:29:00.000Z ==> 15/06/2021-4h29
   */
  public getNiceDateHeure(date: string){
    let newDate = new Date(date);
    return this.getNiceDateHeureFromDate(newDate);
  }

/**
   * Format a date to be user friendly ( DD/MM/YYYY:HH:mm )
   * @param date a valid string representation of the date to format
   * @returns 2021-06-15T04:29:00.000Z ==> 15/06/2021-4h29
   */
 public getNiceDateHeureFromDate(date: Date){
  let hours = date.getHours().toString();
  let minutes = date.getMinutes().toString();

  hours = date.getHours() < 10 ? '0' + hours : hours;
  minutes = date.getMinutes() < 10 ? '0' + minutes : minutes;

  return this.getNiceDateFromDate(date) + ' - ' + hours + 'h' + minutes;
}

    /**
     * Check if a given value is valid. AKA not null, undefined, or emty
     * @param value the value to check
     * @returns true if value is defined, not null, and not empty, false otherwise
     */
    public checkNotEmpty( toCheck: string): boolean {
      if( toCheck == undefined || toCheck == null ) {
        return false;
      }
      if( toCheck.length < 1 ){
        return false;
      }
      return true;
    }
  
}
